// extracted by mini-css-extract-plugin
module.exports = {"bb-hero-tagline":"bb-hero-tagline__UyyzC","bb-hero-tagline--two-lines":"bb-hero-tagline--two-lines__tRY_6"};